import type { TLanguage } from "@/src/services/type";

import { getLocalStorage } from "./localStorageHelper";

export const getCurrentLanguage = (): TLanguage =>
  (getLocalStorage("language") as TLanguage) || "en";

export const staticTranslate = (options: {
  tr: string;
  en: string;
}): string => {
  return getCurrentLanguage() === "en" ? options.en : options.tr;
};
